import { useContext, useEffect, useState } from "react"
import { GlobalContext } from '../_app'

import Link from "next/link"

import { Header, HeaderShim } from "../../fuselage/global/header/header"
import { Footer } from '../../fuselage/theme/2024/layout/footer/footer'

import { StickySidebar } from "../../fuselage/layout/sticky-sidebar/sticky-sidebar"
import { Podcast } from "../../fuselage/components/podcast/podcast"

const podcastLimit = 14



export default function Data () {
    const globals = useContext(GlobalContext)
	const [podcasts, setPodcasts] = useState([])
	const [loading, setLoading] = useState(true)
	const [error, setError] = useState(false)

	useEffect(() => {
		let active = true

		fetch(`/api/latest-podcasts?limit=${podcastLimit}`)
			.then((response) => {
				if (!response.ok) throw new Error(`Podcast request failed: ${response.status}`)
				return response.json()
			})
			.then((data) => {
				if (active) setPodcasts(data.podcasts || [])
			})
			.catch(() => {
				if (active) setError(true)
			})
			.finally(() => {
				if (active) setLoading(false)
			})

		return () => {
			active = false
		}
	}, [])



	return (
		<>
			<Header mainMenu={globals.nodes} />
			<HeaderShim mobileOnly />

			<section className="block bg-medium pt-0">
				<StickySidebar size='small'>
					<aside className="formatted">
                        <HeaderShim desktopOnly/>
                        <p><a className="uLink fs-6 fw-600 c-primary here" href={`/content-library/latest-podcasts`}>Podcasts</a></p>
                        <p><a className="uLink fs-6 fw-600 c-primary" href={`/content-library/latest-videos`}>Videos</a></p>
                        <p><a className="uLink fs-6 fw-600 c-primary" href={`/content-library/press-room`}>Press Room</a></p>
                    </aside>

					<main>
						<HeaderShim desktopOnly/>
						<div>
							<p className="fs-1 fw-600 c-primary">Content Library</p>
							<p className="fs-2 fw-600 caps mt-md mb-sm">Latest Podcasts</p>
						</div>

						<div className="container columns-2 gap-sm">
							{loading ? <p>Loading podcasts...</p> : error ? <p>Unable to load podcasts right now.</p> : podcasts.length ? podcasts.map((podcast, i) => (
									
									<Podcast key={i} data={podcast} />

								)) : <p>No podcasts are available right now.</p>}
						</div>
					</main>
				</StickySidebar>
			</section>

			<Footer
				socialConnections={globals.globalSets[2].socialConnections}
				contactInfo={globals.globalSets[2].contactDetails[0].body}
				hubspotForm={globals.globalSets[2].hubspotForm[0] ? globals.globalSets[2].hubspotForm[0] : null}
			/>
		</>
	)
}


Data.theme = 'aviadev-2024'
